export default __webpack_public_path__ + "static/md_banner-da21c57b2b01c0b3ff257b748b1c5798.png";